import { render, staticRenderFns } from "./yasaipay.vue?vue&type=template&id=54f3e7e4&"
import script from "./yasaipay.vue?vue&type=script&lang=js&"
export * from "./yasaipay.vue?vue&type=script&lang=js&"
import style0 from "./yasaipay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DatePicker: require('/home/runner/work/myody_front/myody_front/components/date/DatePicker.vue').default,FormItem: require('/home/runner/work/myody_front/myody_front/components/form/FormItem.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default,Option: require('/home/runner/work/myody_front/myody_front/components/option/Option.vue').default,Select: require('/home/runner/work/myody_front/myody_front/components/select/Select.vue').default,Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default,TableYasaipayHistory: require('/home/runner/work/myody_front/myody_front/components/table/TableYasaipayHistory.vue').default})
